import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'scriptRequest', en);

const ScriptRequestListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Script Request',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.REPORT,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/script-request',
      component: React.lazy(() => import('./ScriptRequestList')),
    },
  ],
};

export default ScriptRequestListConfig;
